import React from 'react';
import PropTypes from 'prop-types';
import * as Api from 'api';
import * as Actions from 'actions';
import { makeCancelable } from 'utils';
import { connect } from 'react-redux';
import { MapList } from '../';
import { Button } from 'react-bootstrap';
import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import moment from 'moment';

class MapSearchList extends React.Component {
  state = {
    maps : [],
    startDate: moment().subtract(29, 'days'),
    endDate: moment(),
    loading: false,
  }
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    this.handleApply(null, {startDate: this.state.startDate, endDate: this.state.endDate});
  }
  handleApply(event, picker) {
    this.setState({startDate:picker.startDate, endDate: picker.endDate, loading: true})
    this.searchMapsPromise = makeCancelable(Api.searchMaps(JSON.stringify(picker.startDate), JSON.stringify(picker.endDate)));
    this.searchMapsPromise.promise.then(maps => this.setState({maps, loading: false}))
    .catch(error => {
      if(error.isCanceled) {
        return;
      }
      this.props.notify(error)
      this.setState({loading: false, maps: []})
    })
  }
  componentWillUnmount() {
    this.searchMapsPromise.cancel();
  }
  render() {
    const { maps } = this.state;
    let start = this.state.startDate.format('MM-DD-YYYY');
    let end = this.state.endDate.format('MM-DD-YYYY');
    let label = start + ' - ' + end;
    if (start === end) {
     label = start;
    }
    return <div className="map-search-list">
      <DatetimeRangePicker
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onApply={this.handleApply.bind(this)}>
        <div className="input-group">
          <input type="text" className="form-control" readOnly={true} value={label || ''}/>
            <span className="input-group-btn">
                <Button className="default date-range-toggle">
                  <i className="fa fa-calendar"/>
                </Button>
            </span>
        </div>
      </DatetimeRangePicker>
      <hr className="mb-sm" />
      {this.state.loading?
        <p className="text-center"><i className="fa fa-spinner fa-spin"></i> Downloading Maps</p>
      :
      <MapList maps={maps} />}
    </div>
  }
}

export default connect(f => ({}), {notify : Actions.notify})(MapSearchList);



// WEBPACK FOOTER //
// ./src/browser/components/maps/map-search-list.js